import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"WHNAa","textWrapNowrap":"EGXvZ","alignRight":"li3qe","alignCenter":"_0Qz2K","sizeFullWidth":"Exx3f","renderedInTable":"-mcN1","sizeOriginal":"Gr7zo","sizeContent":"_0OB-Q","sizeSmall":"l6-fw","sizeSmallCenter":"MsZYu","flex":"Lk4cM","atomic":"pvj0E","anchor":"-jioT","embed":"f1SDL","horizontalScrollbar":"_6jc4G","pluginContainerMobile":"j8uGU"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-98d0fe86.js.map
